<template>
  <div style="height: auto; min-height: 500px;">
    <div class="phone-selector-container">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem; min-height: 222px;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-else-if="popup">
        <div class="col-12" style="min-height: 60px;">
          <b-alert variant="primary" :show="true">
            {{ $t('login.newWindowAlertLine1', { appName: $whitelabel.getAppName() }) }}<br />
            {{ $t('login.newWindowAlertLine2') }} <span class="link text-teal" @click="loginAgain">{{ $t('login.newWindowAlertLine3') }}</span>, {{ $t('login.newWindowAlertLine4') }}<br />
            {{ $t('login.newWindowAlertLine5') }}
          </b-alert>
        </div>
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-else>
        <div class="col-12" style="min-height: 60px;">
          <b-alert variant="danger" :show="isAlert">{{ $t('login.loginFailAlert') }}</b-alert>
        </div>
        <form method="post" @submit.prevent="login" name="login">
          <div class="col-12">
            <div class="col-12">
              <b-form-input
                id="username"
                v-model="username"
                type="text"
                required
                :placeholder="$t('login.username')"
              ></b-form-input>
            </div>
          </div>
          <div class="col-12" style="margin-top: 1rem;">
            <div class="col-12">
              <b-form-input
                id="password"
                v-model="password"
                type="password"
                required
                :placeholder="$t('login.password')"
              ></b-form-input>
            </div>
          </div>
          <div class="col-10 offset-1" style="margin-top: 2rem;">
            <b-button variant="primary" type="submit" block style="background-color: #009AB1; border-color: #009AB1;">{{ $t('login.login') }}</b-button>
            <br />
            <router-link :to="{name: 'ResetEmail'}" style="color: #009AB1;">{{ $t('login.forgotPassword') }}</router-link>
            <br />
            <a v-if="$whitelabel.showUserGuide()" :href="$whitelabel.getUserGuideUrl()" style="color: #009AB1;">{{ $t('login.userGuide') }}</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'login',
    mounted () {
      var self = this

      var userAgent = navigator.userAgent
      console.log(userAgent)
      if (userAgent.match(/Windows/i)) {
        if (userAgent.match(/Edge/i)) {
          self.isEdge = true
          console.log('Windows Edge Browser')
        } else {
          self.isWChrome = true
          console.log('Windows Chrome Browser')
        }
      }

      localStorage.removeItem('fonestorm-token')
      localStorage.removeItem('device')
      localStorage.removeItem('DND')
      localStorage.removeItem('sound-popup')

      if (self.$route.query.lang) {
        switch (self.$route.query.lang) {
          case 'en':
          case 'es':
          case 'fr':
            self.$root.$i18n.locale = self.$route.query.lang
            break
          default:
            break
        }
      }
    },
    data () {
      return {
        username: '',
        password: '',
        device: null,
        isAlert: false,
        processing: false,
        popup: false,
        windowWidth: window.innerWidth,
        isEdge: false,
        isWChrome: false
      }
    },
    methods: {
      login: async function () {
        var self = this
        if (self.username && self.password) {
          // eslint-disable-next-line
          var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/

          if (filter.test(self.username)) {
            self.fonestormLogin()
          } else {
            self.portalLogin()
          }
        }
      },
      fonestormLogin: async function () {
        var self = this
        var response = null
        try {
          self.processing = true
          self.isAlert = false
          response = await axios.post(`${process.env.FONESTORM_API}/auth`, { username: self.username, password: self.password, expires: 86400 }, {})
          var token = response.data.auth.token
          localStorage.setItem('fonestorm-token', token) // store the token in localstorage
          self.processing = false
          self.popup = true
          if (self.windowWidth >= 800) {
            if (self.isWChrome) {
              window.open('/#/phone', '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=436, height=610')
            } else {
              window.open('/#/phone', '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=420, height=610')
            }
          } else {
            self.$router.push({ name: 'Selection' })
          }
        } catch (error) {
          self.portalLogin()
        }
      },
      portalLogin: async function () {
        var self = this
        var response = null
        try {
          self.processing = true
          response = await axios.post(`${process.env.FONESTORM_API}/devices/fractelfone`, { username: self.username, password: self.password }, {})
          localStorage.setItem('fonestorm-token', response.data.device.fonestorm_token) // store the token in localstorage
          self.processing = false
          self.popup = true
          if (self.$route.query.hostname && self.$route.query.websocket_url) {
            if (self.windowWidth >= 800) {
              if (self.isWChrome) {
                window.open(`/#/phone?hostname=${self.$route.query.hostname}&websocket_url=${self.$route.query.websocket_url}`, '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=436, height=610')
              } else {
                window.open(`/#/phone?hostname=${self.$route.query.hostname}&websocket_url=${self.$route.query.websocket_url}`, '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=420, height=610')
              }
            } else {
              self.$router.push(`/phone?hostname=${self.$route.query.hostname}&websocket_url=${self.$route.query.websocket_url}`)
            }
          } else {
            if (self.windowWidth >= 800) {
              if (self.isWChrome) {
                window.open('/#/phone', '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=436, height=610')
              } else {
                window.open('/#/phone', '', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=420, height=610')
              }
            } else {
              self.$router.push({ name: 'Selection' })
            }
          }
        } catch (error) {
          self.isAlert = true
          self.processing = false
          localStorage.removeItem('fonestorm-token')
          localStorage.removeItem('device')
        }
      },
      loginAgain: async function () {
        var self = this
        if (self.username && self.password) {
          // eslint-disable-next-line
          var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/

          if (self.$route.query.hostname && self.$route.query.websocket_url) {
            self.$router.push(`/phone?hostname=${self.$route.query.hostname}&websocket_url=${self.$route.query.websocket_url}`)
          } else {
            self.$router.push({ name: 'Selection' })
          }
        }
      }
    }
  }
</script>

<style scopped>
.phone-selector-container {
  background-color: white;
  max-width: 420px !important;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  height: 552px !important;
  width: 420px !important;
  overflow: hidden;
  text-align: center !important;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
.text-teal {
  color: #009AB1;
}
.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
